import {
    createStore
} from 'vuex'
import Cookies from 'js-cookie'
//创建实例
export default createStore({
    state: {
        test: 1
    },
    getters: {

    },
    mutations: {
        setTest(state, val) {
            state.test = val
        }
    },
    actions: {
        // 前端 登出
        FedLogOut({
            commit
        }) {
            return new Promise(resolve => {
                Cookies.remove('refresh_token');
                Cookies.remove('access_token');
                resolve()
            })
        },
    },
    modules: {}
})
//仓库导出为一个模块
// export default store;